<template>
  <div class="badge-container cursor-pointer">
    <v-icon color="blue lighten-1" :size="iconSize" class="pa-0 ma-0"
      >mdi-creation-outline</v-icon
    >
  </div>
</template>

<script>
export default {
  name: 'AIIcon',

  props: {
    iconSize: {
      type: String,
      required: false,
      default: '12',
    },
  },
}
</script>
<style lang="scss" scoped>
.badge-container {
  height: 25px;
  width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(#102046 0 0) padding-box,
    conic-gradient(
        from 180deg at 50% 50%,
        #b3d3ff 0deg,
        #3882f0 152.05deg,
        #b3d3ff 360deg
      )
      border-box;
  border: 2px solid transparent;
  border-radius: 50%;
  margin-right: 5px;
}
</style>
